// extracted by mini-css-extract-plugin
module.exports = {"terms":"style__terms__DoQmY"};